<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance "
         id="operatorSelectModal">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="modal__header">
          <p class="top_disclaimer_extra">
            {{ showUpperDisclaimer() }}
          </p>
          <h1>{{ getTranslations.home_modals_select_operator_register }}</h1>
          <img :src="getTranslations.project_config_modal_img" alt="">
          <img class="hidden_modal_logo" :src="getTranslations.project_logo_img">
        </div>
        <div class="modal__body">
          <div class="operators_selection_wrap">
            <h1>{{ getTranslations.visitor_sign_up_1_single_country_my_operator }}</h1>
            <p>{{ getTranslations.home_modals_select_operator_my_operator_is }} </p>
            <div v-if="displayOperatorsLength <= 4" class="operators_radio">
              <label v-for="(operator, index) in multiOperatorInfo.multiOperatorKeys"
                     v-if="multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage[index]"
                     class="operators_radio operators_radio_inline"
                     :key="index">
                <img class="operators_icon"
                     :src="getOperatorImage(index)"
                     :alt="getOperatorDisplayName(index)">
                <input type="radio"
                       name="operator"
                       :value="operator"
                       v-model="inputOperator"
                       @click="check();getOrdinalByOperator(operator);">
                <span></span>
              </label>
            </div>
            <div v-else  class="operators_radio" v-for="groupIndex in Math.ceil(multiOperatorInfo.multiOperatorKeys.length / 3)" :key="groupIndex">
              <label v-for="(operator, index) in getOperatorIndexes(groupIndex)"
                     v-if="multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage[getAdjustedIndex(groupIndex, index)]"
                     class="operators_radio operators_radio_inline"
                     :key="index">
                <img class="operators_icon"
                     :src="getOperatorImage(getAdjustedIndex(groupIndex, index))"
                     :alt="getOperatorDisplayName(getAdjustedIndex(groupIndex, index))">
                <input type="radio"
                       name="operator"
                       :value="operator"
                       v-model="inputOperator"
                       @click="check();
                       getOrdinalByOperator(operator);">
                <span></span>
              </label>
            </div>
            <div class="operators_error_msg"
                 v-if="!inputOperator && btnSubmitted">
              <span class="form-group__feedback">
                {{ getTranslations.visitor_sign_up_1_single_country_select_operator }}
              </span>
            </div>
          </div>
          <form action="" v-on:submit.prevent="goToNext()">
            <div  :class="[ 'form-group', !errors ? 'has-success' : 'has-warning' ]">
              <a>{{ getAbovePlaceholderText() }}</a>
              <input type="text"
                     class="form-group__textfield phone_input"
                     :placeholder="getPlaceholder()"
                     @keyup="check"
                     v-model="inputMsisdn"/>
              <span class="form-group__feedback"
                    v-if="ERROR_REDIRECT_MESSAGE">
                {{ getMessage(mapErrorMessages(ERROR_REDIRECT_MESSAGE)) }}
              </span>
            </div>
            <a @click.prevent="goToNext()"
               style="cursor:pointer"
               :class="['btn2 btn2--std btn2--small', (errors)? 'deactivated' : '']">
              {{ getTranslations.visitor_sign_up_1_single_country_submit_button_continue }}
          </a>
            <br><br>
            <a style="cursor: pointer"
               @click.prevent="exit()"
               class="alter_flow_link">
              {{ getExitButtonText() }}
            </a>
          </form>
          <p class="bottom_disclaimer_extra">
            {{ showExtraDisclaimer() }}
          </p>
          <p v-if="showDisclaimer()">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_disclaimer') }}</p>
          <p class="form-group__feedback reg_notice" v-if="inputOperator">
            {{ getTranslations.visitor_operator_selection_modal_terms_conditions }}
            <a style="cursor: pointer"
               target="_blank"
               class="alter_flow_link"
               :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')">
              {{ getTranslations.visitor_operator_selection_modal_terms_conditions_click }}
            </a>
          </p>
        </div>
        <div class="modal__footer"></div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';

export default {
  name: 'operatorSelectionModal',
  mixins: [IntegrationMixin],
  created() {
    this.displayOperatorsLength = this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.filter(value => value === true).length;
    this.multiOperatorKeysSecondArray = this.multiOperatorInfo.multiOperatorKeys;
    this.inputMsisdn = (this.getTranslations.visitor_msisdn_input_prefix_value) ? this.getTranslations.visitor_msisdn_input_prefix_value : '';
    const numOfVisibleOperators = (this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.filter(item => item)).length;
    if (numOfVisibleOperators === 1) {
      const position = this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.indexOf(true);
      const operator = this.multiOperatorInfo.multiOperatorKeys[position];
      this.storeOperator(operator);
      this.inputOperator = operator;
    }
    this.showModal();
  },
  mounted() {
    this.tpayWifiFlow();
  },
  data() {
    return {
      displayOperatorsLength: 0,
      inputMsisdn: '',
      inputOperator: '',
      errors: false,
      btnSubmitted: false,
      multiOperatorKeysSecondArray: [],
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
    ]),
    ...mapActions('common', [
      'storeOperator',
    ]),
    getAdjustedIndex(groupIndex, index) {
      if (groupIndex >= 2) {
        return index + 3;
      }
      return index;
    },
    getOperatorIndexes(groupIndex) {
      if (groupIndex >= 2) {
        this.multiOperatorKeysSecondArray = this.multiOperatorInfo.multiOperatorKeys;
      }
      const start = (groupIndex - 1) * 3;
      const end = start + 3;
      return this.multiOperatorKeysSecondArray.slice(start, end);
    },
    exit() {
      window.location.href = 'https://google.com';
    },
    getPlaceholder() {
      if (!this.inputOperator) return this.getTranslations.visitor_sign_up_1_single_country_placeholder;
      return this.getTranslationByOperatorIfExists(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_placeholder');
    },
    getExitButtonText() {
      if (!this.inputOperator) return '';
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit');
    },
    showUpperDisclaimer() {
      if (!this.inputOperator) return '';
      return this.getTranslationByOperatorIfExists(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_upper_disclaimer');
    },
    getAbovePlaceholderText() {
      if (!this.inputOperator) return this.getTranslations.visitor_sign_up_1_single_country_above_placeholder;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_above_placeholder');
    },
    showExtraDisclaimer() {
      if (!this.inputOperator) return '';
      return this.getTranslationByOperatorIfExists(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_extra_disclaimer');
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.inputOperator;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_disclaimer');
    },
    mapErrorMessages(resMessage) {
      if (resMessage === 'MSISDN_INVALID') {
        return 'visitor_sign_up_invalid_msisdn_msg';
      } else if (resMessage === 'ALREADY_REGISTERED') {
        return 'visitor_sign_up_msisdn_already_registered';
      } else if (resMessage === 'MSISDN_NOT_EXIST') {
        return 'visitor_sign_up_msisdn_not_exists';
      } else if (resMessage === 'MSISDN_BLACKLISTED') {
        return 'visitor_sign_up_msisdn_blacklisted';
      } else if (resMessage === 'BLOCKED_USER') {
        return 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resMessage === 'SERVER_ERROR') {
        return 'home_profile_profile_edit_server_unvailable';
      } else if ((resMessage === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resMessage === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resMessage === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        return 'visitor_sign_up_warning_third_party_error';
      }
      return '';
    },
    getOrdinalByOperator(operator) {
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((res) => {
        this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
      });
    },
    tpayWifiFlow() {
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name) {
        const code = this.getOperatorCode('WE_EGY');
        /* eslint-disable */
        console.log('opCode: ', code);
        sessionStorage.setItem('operator', 'WE_EGY');
        TPay.HeaderEnrichment.init({ operatorCode: '60204' });
        /* eslint-enable */
      }
    },
    check() {
      const validMsisdnRegex = /^[0-9]{0,20}$/;
      const validMsisdn = this.inputMsisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
        this.errors = true;
      } else {
        this.errors = false;
        this.ERROR_REDIRECT_MESSAGE = '';
      }
    },
    getOperatorCode(operator) {
      let code;
      switch (operator) {
      case 'ORANGE_EGY':
        code = '60201';
        break;
      case 'VODAFONE_EGY':
        code = '60202';
        break;
      case 'ETISALAT_EGY':
        code = '60203';
        break;
      case 'WE_EGY':
        code = '60204';
        break;
      default:
        break;
      }
      return code;
    },
    async prepareConfirm() {
      /* eslint-disable */
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name) {
        let msisdn = this.inputMsisdn;
        if (this.inputMsisdn.startsWith('01')) { // Transformation from 01 to 201
          msisdn = '2' + msisdn;
        }
        console.log('Transformed msisdn: ', msisdn);
        if (this.inputMsisdn.length > 5) { // msisdn field gets filled up
          let obj = {
            msisdn: this.inputMsisdn,
            subscriptionPlanId: '1975',
            productCatalog: 'Play_and_win',
            productSku: 'Play_Win',
            operatorCode: this.getOperatorCode(sessionStorage.getItem('operator')),
            customerAccountNumber: sessionStorage.getItem('can'),
          };
          console.log('Confirm return obj = ', obj);
          try {
            TPay.HeaderEnrichment.confirm(obj,
              async function (status, refCode, contract) {
                console.log('status: ' + status + ' refcode: ' + refCode + ' contract: ' + contract);
                if (status === true) { // No error or fail case
                  sessionStorage.setItem('status', status);
                  sessionStorage.setItem('refcode', refCode);
                  sessionStorage.setItem('contract', contract);
                  // Wifi flow
                  const sessionToken = await TPay.HeaderEnrichment.sessionToken();
                  console.log('Got sessionToken: ', sessionToken);
                }
              }
            );
          } catch (error) {
            console.error(error);
            return false;
          }
          const sessionToken = await TPay.HeaderEnrichment.sessionToken();
          sessionStorage.setItem('sessionToken', sessionToken);
        }
      }
      return true;
      /* eslint-enable */
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    async goToNext() {
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name) {
        const nextStepCall = await this.prepareConfirm();
        console.log('NEXT STEP CALL: ', nextStepCall);
        if (nextStepCall) {
          this.nextSteps();
        }
      } else {
        this.nextSteps();
      }
    },
    nextSteps() {
      this.btnSubmitted = true;
      if (this.inputMsisdn && this.inputOperator) {
        this.setRegistrationInfo(this.inputMsisdn);
        this.storeOperator(this.inputOperator);
        const appropriateRequestPinStep = this.getAlternateRequestPinAction(); // integration specific
        if (appropriateRequestPinStep) {
          appropriateRequestPinStep.call(this, this.inputMsisdn, this.inputOperator);
        } else { // default
          this.setActiveIntegrationInfo([{ key: 'msisdn', value: this.inputMsisdn }, { key: 'operator', value: this.inputOperator }, { key: 'lang', value: this.getLocale }]);
          this.integrationRedirect();
        }
      } else {
        this.errors = true;
      }
    },
    showModal() {
      const vm = this;
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          vm.$emit('close');
          $('.modal, .modal-overlay').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslationByOperatorIfExists',
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/OperatorSelectionModal.vue